<template>
    <div class="modal fade" id="modal-decline-reason" tabindex="-1" role="dialog" aria-labelledby="modal-decline-reason" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <h3>Why did you withdraw the request?</h3>
                    <button
                        v-for="option in withdrawalOptions"
                        :key="option.id"
                        type="button"
                        class="btn btn-block btn-dark"
                        data-dismiss="modal"
                        @click="handleWithdrawRequestReasonCallback(option.id)">
                        {{ option.label }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  methods: {
    handleWithdrawRequestReasonCallback (reason) {
      this.$emit('input', reason)
    }
  },

  computed: {
    withdrawalOptions () {
      const adminWithdrawalOptions = [
        { id: 'call', label: 'Did Not Return Calls' },
        { id: 'talent_uninterested', label: this.$options.filters.sentenceCase(this.$starLabelPlural) + ' Not Interested' },
        { id: 'client_uninterested', label: 'Client Uninterested In Applicants' },
        { id: 'pickstar', label: this.clientName + ' Admin Withdraw' },
        { id: 'replacement_found', label: 'Replacement Found' },
        { id: 'duplicate', label: 'Duplicate' },
        { id: 'closing_multiple_star_requests', label: `Closing multiple ${this.$starLabel} request` },
        { id: 'test', label: 'Admin Test' }
      ]
      const generalWithdrawalOptions = [
        { id: 'budget', label: 'Budget Issues' },
        { id: 'not_proceeding', label: 'Request Not Proceeding' },
        { id: 'elsewhere', label: this.$options.filters.sentenceCase(this.$starLabelPlural) + ' Sourced Elsewhere' },
        { id: 'covid19', label: 'COVID-19' },
        { id: 'preferred_star_unavailable', label: `Preferred ${this.$starLabel} unavailable` }
      ]
      const otherWithdrawalOptions = [
        { id: 'applicants', label: 'No Suitable Applicants' }
      ]
      if (this.$userIsAdmin) {
        return [
          ...generalWithdrawalOptions,
          ...adminWithdrawalOptions
        ]
      } else {
        return [
          ...generalWithdrawalOptions,
          ...otherWithdrawalOptions
        ]
      }
    }
  }
}
</script>
